/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import classNames from 'classnames';
import React from 'react';
import EmergencyAlertDisplay from '../../../../Features/EmergencyAlerts/EmergencyAlertDisplay';
import styles from './body.module.css';

interface StandardLayoutBodyProps {
    handleBodyClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
    children: React.ReactNode;
    navIsOpen: boolean;
}

function StandardLayoutBody({
    handleBodyClick,
    children,
    navIsOpen,
}: StandardLayoutBodyProps): React.ReactElement<StandardLayoutBodyProps> {
    return (
        <div onClick={handleBodyClick} className={classNames(styles.CoreBody, { [styles.CollapsedNavigation]: !navIsOpen })}>
            <div className={styles.CoreContent}>
                <EmergencyAlertDisplay />
                {children}
            </div>
        </div>
    );
}

export default StandardLayoutBody;
